import { Box, Text, Image } from 'rebass';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import { createMemoirStoryRequest, updateMemoirStoryRequest } from 'story-requests/api';
import CopyLink from './CopyLink';
import useEntity from 'entities/hooks/use-entity';
import StoryRequestPNG from './assets/new-story-request.png'

const NewStoryRequest = () => {
  const { type, id: memoirId } = useParams()
  const { width } = useWindowSize();
  const [storyRequestData, setStoryRequestData] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)


  useEffect(() => {
    if (!storyRequestData?.id) {
      const attributes = {
        "contributor-experience": 'other_contributors',
      }
      onSubmit(attributes)
    }
  }, [storyRequestData?.id])

  async function onSubmit(attributes) {
    setIsSubmitting(true)
    if (!storyRequestData?.id) {
      const { data: { initial: { data } } } = await createMemoirStoryRequest({ memoirId, attributes })

      setStoryRequestData(data?.attributes)
    }
    else {
      const { data: { initial: { data } } } = await updateMemoirStoryRequest({ memoirId, memoirStoryRequestId: storyRequestData?.id, attributes })
      setStoryRequestData(data?.attributes)
    }
    setIsSubmitting(false)
  }

  return <Box m={width < 600 ? 2 : 4} mr={2}>
    <Text fontFamily="Poppins" fontSize={22} letterSpacing="0.22px" lineHeight="165%">
      Request a Story
    </Text>
    <Box m="auto" my={2} backgroundColor='rgba(0, 0, 0, 0.05)' height="1px" maxWidth="100%" />
    <Box maxWidth={480} m="auto">
      <Image my={3} src={StoryRequestPNG} width="100%" />
      <Text color="#64748B" fontFamily="Poppins" fontSize="18px" letterSpacing="0.36px" lineHeight="150%">
        Share a link to have loved ones tell a story. After they submit the story to you, you can edit it in your “All Stories” tab.
        <br />
        <br />
        Copy and share the link:
      </Text>
      {(!isSubmitting && storyRequestData) && <CopyLink
        storyRequestData={storyRequestData}
        // storyRequestData={storyRequestData}
        memoirId={memoirId}
      />}
    </Box>

  </Box>

  {/* {closeModal && <ConfirmationModal
      message="Are you sure you want to cancel this story request?"
      deleteLabel="Cancel story Request"
      onCancel={() => setCloseModal(false)}
      onConfirm={() => {
        replace(`${route}`)
      }}
    />}
    <Box sx={{
      position: 'absolute',
      height: step === 4 ? `100vh` : [`calc(100vh - 150px)`, `calc(100vh - 50px)`],
      width: '100%',
      overflowY: 'scroll',
      maxWidth: 500,
      '-webkit-overflow-scrolling': 'touch',
      touchAction: 'auto',
      mt: 2
    }}>
      <SectionRender isStillAlive={memoir?.['subject-alive']} subjectRelation={memoir?.['subject-relation']} created_memoir_story_request_id={created_memoir_story_request_id} replace={replace} memoirId={id} type={type} step={step} onStepUp={onStepUp} onStepDown={onStepDown} />
    </Box> */}
  {/* </Modal> */ }
};

NewStoryRequest.propTypes = {

};

export default NewStoryRequest;
